/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import AppLoadingRoot from '@/components/AppLoadingRoot'
import { buildLoginUrl } from '@/lib/urlUtils'

const PartnerSignupLogin: React.FunctionComponent = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (location.state?.hasExistingSubscription === undefined) {
      const loginUrl = buildLoginUrl({ locationQueryString: location.search })

      navigate(loginUrl, {
        replace: true,
        state: { hasExistingSubscription: true },
      })
    }
  }, [])

  return <AppLoadingRoot />
}

export default PartnerSignupLogin
